// Cart price-drop animation. When a cart re-render makes a line cheaper -- the second PS4
// controller tipping an automatic "2 for $13" discount, say -- the line price and the
// total count down from the old figure to the new one, the struck-through original and
// the discount row slide in, and a toast names the discount once.
//
// Public API (used by cart-drawer.js and cart.js):
//   theme.priceDrop.snapshot(root)            -> { lines: {key: cents}, total, titles }
//   theme.priceDrop.play(root, before, {delay})
//   theme.formatMoney(cents, format)
//
// The cart is the source of truth: everything here reads the cents Liquid stamped into
// the fresh markup (data-price-amount, data-total-cents, data-discount-title), so it works
// for any discount, and knows nothing about which products an offer covers.
window.theme = window.theme || {};
(function (t) {
  var DURATION = 600;

  function delimit(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split(".");
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  // Shopify's money_format placeholders. The count needs every in-between figure, so it
  // cannot borrow the server's formatting; the final frame restores the server's text.
  t.formatMoney = function (cents, format) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format || "");
    if (!m) return String(cents / 100);
    var value;
    switch (m[1]) {
      case "amount_no_decimals": value = delimit(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": value = delimit(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = delimit(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = delimit(cents, 2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": value = delimit(cents, 0, " ", ","); break;
      case "amount_with_space_separator": value = delimit(cents, 2, " ", ","); break;
      case "amount_with_period_and_space_separator": value = delimit(cents, 2, " ", "."); break;
      default: value = delimit(cents, 2, ",", ".");
    }
    // A format may carry markup (<span class=money>); the targets are text nodes.
    return format.replace(m[0], value).replace(/<[^>]*>/g, "");
  };

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  // Lines are matched by key, then by variant. Shopify folds a line's discounts into its
  // key, so the very re-render that applies a discount hands the line a NEW key (seen on
  // the live store: 48032069976262:0fda09... became ...:14e660... when "2 for $13" landed).
  // A variant that sat on two lines is ambiguous and stored as null: no guessing.
  function snapshot(root) {
    var s = { lines: {}, byVariant: {}, total: null, titles: [] };
    if (!root) return s;
    each(root, "[data-line-key]", function (line) {
      var amount = line.querySelector("[data-price-amount]");
      if (!amount) return;
      var cents = Number(amount.dataset.priceAmount);
      s.lines[line.dataset.lineKey] = cents;
      var v = line.dataset.variantId;
      if (v) s.byVariant[v] = v in s.byVariant ? null : cents;
    });
    var total = root.querySelector("[data-total-cents]");
    if (total) s.total = Number(total.dataset.totalCents);
    each(root, "[data-discount-title]", function (el) { s.titles.push(el.dataset.discountTitle); });
    return s;
  }

  // One toast per discount that was not in the cart before. Several lines share one
  // automatic discount, so titles are de-duplicated.
  function announce(root, before) {
    if (!t.toast) return;
    var seen = {};
    (before.titles || []).forEach(function (x) { seen[x] = true; });
    var tpl = (t.strings && t.strings.discountApplied) || "__TITLE__";
    each(root, "[data-discount-title]", function (el) {
      var title = el.dataset.discountTitle;
      if (!title || seen[title]) return;
      seen[title] = true;
      t.toast(tpl.replace("__TITLE__", title), { type: "success" });
    });
  }

  function play(root, before, opts) {
    if (!root || !before) return;
    var delay = (opts && opts.delay) || 0;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var runs = [];

    each(root, "[data-line-key]", function (line) {
      var amount = line.querySelector("[data-price-amount]");
      var from = before.lines && before.lines[line.dataset.lineKey];
      if (from == null && before.byVariant && line.dataset.variantId) from = before.byVariant[line.dataset.variantId];
      if (!amount || from == null) return;
      var to = Number(amount.dataset.priceAmount);
      if (!(to < from)) return;
      runs.push({ el: amount, from: from, to: to });
      if (reduce) return;
      each(line, "[data-price-compare], [data-discount-title]", function (el) {
        el.style.animationDelay = delay + "ms";
        el.classList.add("jg-price-drop-in");
      });
    });

    var total = root.querySelector("[data-total-cents]");
    if (total && before.total != null && Number(total.dataset.totalCents) < before.total) {
      runs.push({ el: total, from: before.total, to: Number(total.dataset.totalCents) });
    }

    announce(root, before);
    if (reduce || !t.moneyFormat || !runs.length) return;

    // Start on the old figure straight away, so a delayed count (the drawer still sliding
    // in) never flashes the new price first.
    runs.forEach(function (r) {
      r.final = r.el.textContent;
      r.el.textContent = t.formatMoney(r.from, t.moneyFormat);
    });
    setTimeout(function () {
      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var p = Math.min(1, (now - start) / DURATION);
        var eased = 1 - Math.pow(1 - p, 3);
        runs.forEach(function (r) {
          r.el.textContent = p < 1
            ? t.formatMoney(Math.round(r.from + (r.to - r.from) * eased), t.moneyFormat)
            : r.final;
        });
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }, delay);
  }

  t.priceDrop = { snapshot: snapshot, play: play };
})(window.theme);
